import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Popover } from 'antd';
import Icon from '@components/Icon';
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

// emoji-mart 支持的语言映射
// 将我们的语言代码映射到 emoji-mart 支持的语言代码
const emojiMartLocaleMap = {
    'en': 'en',
    'zh': 'zh',
    'zh-TW': 'zh',
    'ja': 'ja',
    'ko': 'ko',
    'es': 'es',
    'pt': 'pt',
    'fr': 'fr',
    'de': 'de',
    'hi': 'hi',
    'ru': 'ru',
    'ar': 'ar',
    'id': 'id',
    'bn': 'bn',
    'it': 'it',
    'tr': 'tr',
    'vi': 'vi',
    'th': 'th',
    'pl': 'pl',
    'uk': 'uk',
    'ms': 'ms',
    'nl': 'nl',
    'ur': 'ur',
    'fa': 'fa',
    'tl': 'tl',
    'ha': 'ha',
};

// 获取 emoji-mart 支持的语言代码
const getEmojiMartLocale = (languageCode) => {
    // 如果直接传入且存在于映射中，直接返回
    if (emojiMartLocaleMap[languageCode]) {
        return emojiMartLocaleMap[languageCode];
    }
    
    // 处理带地区代码的语言（如 zh-CN, en-US）
    const baseLang = languageCode.split('-')[0];
    if (emojiMartLocaleMap[baseLang]) {
        return emojiMartLocaleMap[baseLang];
    }
    
    // 默认返回英文
    return 'en';
};

export default ({disabled = false, toSelect, locale, theme='auto', customButton = null}) => {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    
    // 根据当前语言自动设置 locale，如果没有传入 locale 参数
    const emojiLocale = locale || getEmojiMartLocale(i18n.language);
    
    const hide = () => {
        setOpen(false);
    };
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };
    const onEmojiSelect = (e) => {
        toSelect(e.native);
        hide();
    }
    return (
        <Popover
            content={<Picker data={data} locale={emojiLocale} onEmojiSelect={onEmojiSelect} previewPosition='none' theme={theme} />}
            title=""
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
        >
            {customButton || (
                <Button
                    type="text"
                    shape="circle"
                    disabled={disabled}
                    icon={<Icon.Smile size={16} />}
                />
            )}
        </Popover>
    )
}